<template>
    <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
    >
        <template #button-content>
            <div class="d-md-flex d-none user-nav">
                <p class="user-name font-weight-bolder mb-0">
                    {{ userData.name }}
                </p>
                <span class="user-status">{{ userData.rol.nRol }}</span>
            </div>
            <b-avatar
                size="40"
                :src="userData.avatar"
                variant="light-primary"
                badge
                class="badge-minimal"
                badge-variant="success"
            >
                <feather-icon
                    v-if="!userData.name"
                    icon="UserIcon"
                    size="22"
                />
            </b-avatar>
        </template>

        <b-dropdown-item
            :to="{ name: 'perfil' }"
            link-class="d-flex align-items-center"
        >
            <feather-icon
                size="16"
                icon="UserIcon"
                class="mr-50"
            />
            <span>Perfil</span>
        </b-dropdown-item>

        <b-dropdown-item
            :to="{ name: 'empresa' }"
            link-class="d-flex align-items-center"
        >
            <feather-icon
                size="16"
                icon="HexagonIcon"
                class="mr-50"
            />
            <span>Empresa</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item
            link-class="d-flex align-items-center"
            @click="logout"
        >
            <feather-icon
                size="16"
                icon="LogOutIcon"
                class="mr-50"
            />
            <span>Salir</span>
        </b-dropdown-item>
    </b-nav-item-dropdown>
</template>

<script setup lang="ts">
import { initialAbility } from '@/libs/acl/config'
import { useAbility } from '@/module/shared/composables/useAbility'
import { useUserData } from '@/module/shared/composables/useUserData'
import { useAuthStore } from '@/store/auth/repository/useAuthStore'
import { useRouter } from '@/utils/composition'

const userData = useUserData()
const authStore = useAuthStore()
const ability = useAbility()
const router = useRouter()

const logout = async () => {
    try {
        authStore.detachWebPushToken()
        await authStore.logout()
        ability.update(initialAbility)
    } finally {
        localStorage.clear()
        router.push({ name: 'auth-login' })
    }
}
</script>
